import { every, find, includes, map } from "lodash";
import useSWR from "swr";
import { Product, Setting } from "../models";
import fetcher from "./fetcher";

export const useSettings = ({
    companyId,
    locationId,
}: {
    companyId?: string;
    locationId?: string;
}) => {
    const getAPI = () => {
        if (!companyId) {
            return null;
        }
        if (!locationId) {
            return `/api/permission-management/v1/companies/${companyId}`;
        }
        return `/api/permission-management/v1/companies/${companyId}/locations/${locationId}`;
    };
    const { data, error, isLoading } = useSWR(getAPI(), fetcher, {
        fallbackData: [],
    });

    // check every combination of product id + module id
    const hasProductModules = (products: Product[]): boolean => {
        return every(products, (productToCheck) => {
            const settingsProduct = find(data?.products, {
                id: productToCheck?.id,
            });
            if (settingsProduct) {
                const moduleIdsToCheck = map(productToCheck.modules, "id");
                const settingsModuleIds = map(settingsProduct.modules, "id");
                return every(moduleIdsToCheck, (id) =>
                    includes(settingsModuleIds, id)
                );
            }
            return false;
        });
    };

    return {
        settings: data as Setting,
        isLoadingSettings: isLoading,
        isError: error,
        hasProductModules,
    };
};
